import React from "react";
import LkDeliveryCard from "./LkDeliveryCard";

const LkDeliveryCards = (props) => {
    return(
        <div className="h-full pt-[24px] md:pb-[100px] flex flex-wrap justify-center gap-[20px] md:overflow-y-auto hide-scrollbar">
           
           {
                props.orderList.map((el, index) => (
                    <LkDeliveryCard data={props.data} key={index} el={el} />
                ))
            }

            


        </div>
    )
}

export default LkDeliveryCards;
